import { EMerchantType } from '@app/store/authStore';
import { TPathOptions } from '@app/types/types';
import { ROUTES } from './routes';

export function generateCustomSectionedMenus(
	merchantType?: EMerchantType
): TPathOptions[] {
	return [];
}
